module.exports = __webpack_public_path__ + "static/media/list-ul.32043963.svg";